module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"head":{"meta":{"title":"Refine search for Seminar","description":"TODO:このページの説明文をここに記述する(※Googleの検索結果に表示されるのでよく考える事!)"}},"title":{"period":"Period","industry":"Industry","prefecture":"Prefecture","company_type":"Corporation Type"},"label":{"free_word":"Free word","select":"Select","freeword_text":"ex. Company name, job title, etc."}}}')
  delete Component.options._Ctor
}
